export const revenueDisplayNameMap: Record<string, string> = {
  '82b574835ad1d6d454efd860': '缤纷奶茶乐',
  'cc3c845b883b3a90238386': '拼个图',
  '209b4454fb604c32e0658': '占下那座塔',
  '646684144900c2f16523': '占下那座塔',
  '7e4934f869cc1c5d6e3ab': '占下那座塔',
  'f0d6443968fcaaaacfd8124a1': '占下那座塔',
  'f6d714bfea51f7a79987b': '占下那座塔',
  '9e6e9418ea8b80ba0a7e695': '占下那座塔',
  '0bc044edbb65ae08d79ed': '小小合成师',
  '15d8d4af6933be2fa447': '快乐螺丝厂',
  '62fa848d19967dd71e97': '快乐螺丝厂',
  '6b0e4485dac75c74a92d0540f': '快乐螺丝厂',
}

export const getRevenueDisplayName = (dbtId: string, fallbackName: string) => {
  return revenueDisplayNameMap[dbtId] || fallbackName
}
